
import React from "react";
// import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

// Old image imports kept for future use
/*
import AshishLamba from "../../../assets/images/team/Ashish Lamba.png";
import Dhananjai from "../../../assets/images/team/Dhananjai Jaiswal.png";
import SagarSaini from "../../../assets/images/team/Sagar Saini.png";
import SunilSingh from "../../../assets/images/team/Sunil Singh.png";
*/

function Main() {
  // OLD DATA - kept for future use
  /*
  const data = [
    {
      id: 1,
      img: SunilSingh,
      name: "Sunil Singh",
      subname: "CBO",
    },
    {
      id: 2,
      img: SagarSaini,
      name: "Sagar Saini",
      subname: "Senior Manager",
    },
    {
      id: 3,
      img: Dhananjai,
      name: "Dhananjai Jaiswal",
      subname: "National Sales Head",
    },

    {
      id: 4,
      img: AshishLamba,
      name: "Ashish Lamba",
      subname: "Marketing Officer",
    },
  ];
  */
  // NEW DATA - only two directors, no images
  const data = [
    {
      id: 1,
      name: "Ashish Lamba",
      subname: "Executive Director",
    },
    {
      id: 2,
      name: "Deepak Sharma",
      subname: "Non-Executive Director",
    },
  ];

  return (
    <>
      <section className="team-one">
        <div className="container">
          <div className="sec-title text-center">
            <h3 className="sec-title__tagline">
            meet our senior team
          </h3>
        </div>
        {/* Director Section */}
<div className="director-heading">
  <div className="director-heading__title">
    <span className="director-heading__brace">&#125;</span>
    <h2>Director</h2>
  </div>

  {/* <span className="director-heading__badge">
    Director
  </span> */}
          </div>

           {/* OLD SWIPER - kept for future use
          <Swiper
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 5000 }}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
          >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="team-card">
                  <div className="team-card__image">
                    <img src={item.img} alt={item.name} />
                  </div        
                                       <div className="team-card__content">                  <h3 className="team-card__title">
                     {item.name}
                    </h3>
                    <p className="team-card__designation">
                    {item.subname}
                  </p>
                </div>
              </div>
              </SwiperSlide>
          ))}
        </Swiper>
        */}

        {/* NEW DIRECTOR SECTION */}
        <Swiper
          spaceBetween={20}
          loop={false}
          slidesPerView={2}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
          }}
          className="director-swiper"
        >
          {data.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="director-card">
                <div className="director-card__content">
                  <h3 className="director-card__title">
                    {item.name}
                  </h3>
                  <p className="director-card__designation">
                    {item.subname}
                  </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Main;
